import React from 'react';
import { BuildingIcon, MonitorIcon, ServerIcon, MonitorSmartphoneIcon, MicIcon, LanguagesIcon, UsersIcon, HeartHandshakeIcon, TrendingUpIcon } from 'lucide-react';
export function Benefits() {
  const benefits = [{
    icon: <BuildingIcon className="w-6 h-6" data-id="element-1" />,
    title: 'Department-wise Routing',
    description: 'Efficiently manage tokens across multiple departments and counters.'
  }, {
    icon: <MonitorIcon className="w-6 h-6" data-id="element-2" />,
    title: 'Real-time Displays',
    description: 'Live queue progress displays keep waiting areas informed and calm.'
  }, {
    icon: <ServerIcon className="w-6 h-6" data-id="element-3" />,
    title: 'Secure Local Server',
    description: 'On-premise deployment ensures your data remains secure and private.'
  }, {
    icon: <MonitorSmartphoneIcon className="w-6 h-6" data-id="element-4" />,
    title: 'Self-service Kiosk',
    description: 'Upcoming integration for visitors to print their own token slips.'
  }, {
    icon: <MicIcon className="w-6 h-6" data-id="element-5" />,
    title: 'Hybrid Announcements',
    description: 'Combine live recorded names with pre-recorded department audio.'
  }, {
    icon: <LanguagesIcon className="w-6 h-6" data-id="element-6" />,
    title: 'Multilingual Support',
    description: 'Announcements available in both Nepali and English languages.'
  }, {
    icon: <UsersIcon className="w-6 h-6" data-id="element-7" />,
    title: 'Reduced Congestion',
    description: 'Organized flow minimizes crowding in front desks and waiting areas.'
  }, {
    icon: <HeartHandshakeIcon className="w-6 h-6" data-id="element-8" />,
    title: 'Enhanced Experience',
    description: 'Personalized calling and clear tracking improves customer satisfaction.'
  }, {
    icon: <TrendingUpIcon className="w-6 h-6" data-id="element-9" />,
    title: 'Improved Productivity',
    description: 'Automated routing and calling frees up staff to focus on service.'
  }];
  return <section id="benefits" className="py-24 bg-white" data-id="element-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-11">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-12">
          <h2 className="text-3xl md:text-4xl font-bold text-heading mb-4" data-id="element-13">
            Key Benefits
          </h2>
          <p className="text-lg text-slate-600" data-id="element-14">
            Everything you need to deliver faster, smarter, and more organized
            services.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-15">
          {benefits.map((benefit, index) => <div key={index} className="bg-white border border-slate-200 rounded-xl p-6 hover:shadow-lg hover:border-slate-300 transition-all duration-300 group" data-id="element-16">
              <div className="w-12 h-12 rounded-lg bg-slate-50 border border-slate-100 flex items-center justify-center text-primary mb-5 group-hover:bg-primary group-hover:text-white transition-colors" data-id="element-17">
                {benefit.icon}
              </div>
              <h3 className="text-lg font-bold text-heading mb-2" data-id="element-18">
                {benefit.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed" data-id="element-19">
                {benefit.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}